import { getTypesHandler } from './getTypes';

export const getSelectedDataHandler = component => {
  const getTypes = getTypesHandler(component);
  const { state } = component;

  return () => {
    let resultData;
    let item;
    const results = state.result;
    let { selected } = state;

    if (results) {
      if (results?.bestMatch?.length) {
        if (!selected) {
          return results.bestMatch[0];
        }
        selected -= 1;
      }

      if (results.nowPlaying) {
        if (selected < results.nowPlaying.length) {
          return results.nowPlaying[selected];
        }
        selected -= results.nowPlaying.length;
      }

      getTypes().forEach(type => {
        resultData = (results[type.key] || {}).data;
        if (!resultData || !resultData.length) {
          return;
        }

        if (selected >= 0 && selected < resultData.length) {
          item = resultData[selected];
        }

        selected -= resultData.length;
      });

      return item;
    }

    return undefined;
  };
};
